let config = require('config')

// Get payment provider name
export function getPaymentProviderName() {
  return config.default.payment_provider;
}



// WEBPACK FOOTER //
// ./src/helpers/getPaymentProviderName.js